import { useEffect, useState } from 'react'


const Modal = ({ yesButton, closeModal, children }) => {
    const [shoModal, setShoModal] = useState(true)


    const CloseTheModal = async () => {
        try {
            await closeModal()
            setShoModal(false)
        } catch (error) {
            
        }
    }

    useEffect(() => {
        // Detectar la tecla ESC para cerrar el modal
        const handleEscapeKey = (event) => {
            if (event.key === 'Escape') {
                CloseTheModal()
            }
        }
    
        window.addEventListener('keydown', handleEscapeKey)
    
        return () => {
            window.removeEventListener('keydown', handleEscapeKey)
        }
    }, [])


    return (
        shoModal && (
            <>
                <div className="BackgroundModal"></div>
                <div className="Modal">
                    <button type="button" className="Btn__Adsl--RedOutline Modal__CloseButton" onClick={CloseTheModal}><i className="bi bi-x-lg"></i></button>

                    {children}

                    <div className="Modal__Buttons">
                        <button className="Btn__Adsl--Success Modal__Buttons__Button" onClick={() => yesButton()}>Sí</button>
                        <button className="Btn__Adsl--RedOutline Modal__Buttons__Button" onClick={CloseTheModal}>No</button>
                    </div>
                </div>
            </>
        )
    )
}

export { Modal };